/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var CoverSlug;

(function (CoverSlug) {
  CoverSlug["CYBER_SECURITY"] = "cyber-security";
  CoverSlug["OCCUPATIONAL_PERSONAL_ACCIDENT"] = "occupational-personal-accident";
  CoverSlug["PROFESSIONAL_INDEMNITY"] = "professional-indemnity";
  CoverSlug["PUBLIC_LIABILITY"] = "public-liability";
  CoverSlug["EMPLOYERS_LIABILITY"] = "employers-liability";
  CoverSlug["DIRECTORS_OFFICERS"] = "directors-officers";
  CoverSlug["HIRED_IN_PLANT"] = "hired-in-plant";
  CoverSlug["GOODS_IN_TRANSIT"] = "goods-in-transit";
  CoverSlug["IR35_INSURANCE"] = "ir35-insurance";
  CoverSlug["HIRE_AND_REWARD"] = "hire-and-reward";
  CoverSlug["PORTABLE_EQUIPMENT"] = "portable-equipment";
  CoverSlug["AUTOMOBILE"] = "automobile";
  CoverSlug["EXCESS_LIABILITY"] = "excess-liability";
  CoverSlug["WORKERS_COMPENSATION"] = "workers-compensation";
  CoverSlug["COMMERCIAL_BOND"] = "commercial-bond";
  CoverSlug["CYBER_LIABILITY"] = "cyber-liability";
})(CoverSlug || (CoverSlug = {}));